import Button from '@components/arthurBased/inputs/Button'
import DatePickerInput from '@components/inputs/DatePickerInput'
import { FontWeight } from '@config/theme/sizes'
import {
	Stack,
	styled,
	Typography
} from '@mui/material'
import { useAnalyticsApi } from '@services/api/analytics.api'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import {
	FormattedMessage,
	useIntl
} from 'react-intl'

type AnalyticsFormValues = {
	startDate: string,
	endDate: string
}

const Analytics = () => {
	const { formatMessage } = useIntl()
	const { downloadAnalytics } = useAnalyticsApi()

	const { control, handleSubmit, watch } = useForm<AnalyticsFormValues>()

	const { mutate: downloadAnalyticsMutate } = useMutation<void, Error, AnalyticsFormValues>({
		mutationKey: ['downloadAnalytics'],
		mutationFn: (formValues) => downloadAnalytics(formValues.startDate, formValues.endDate)
	})

	const onSubmit = (values: AnalyticsFormValues) => downloadAnalyticsMutate(values)

	return (
		<Container>
			<Typography variant="h4" fontWeight={FontWeight.SEMI_BOLD}>
				<FormattedMessage id="analytics.title" />
			</Typography>
			<Inputs>
				<DatePickerInput
					control={control}
					name="startDate"
					label={formatMessage({ id: 'analytics.inputs.startDate.label' })}
					isRequired={!watch('endDate')}
				/>
				<DatePickerInput
					control={control}
					name="endDate"
					label={formatMessage({ id: 'analytics.inputs.endDate.label' })}
					isRequired={!watch('startDate')}
				/>
				<Button
					onClick={handleSubmit(onSubmit, console.log)}
				>
					<FormattedMessage id="global.buttons.download" />
				</Button>
			</Inputs>
		</Container>
	)
}

const Container = styled(Stack)({
	rowGap: '24px'
})

const Inputs = styled(Stack)({
	alignItems: 'flex-end',
	columnGap: '16px',
	flexDirection: 'row'
})

export default Analytics
